import $ from 'jquery'
import { Loader } from '@googlemaps/js-api-loader'
import MarkerClusterer from '@googlemaps/markerclustererplus'

import mapIconColors from './constants/map-icon-colors'
import mapStyles from './constants/map-styles'

const backgroundColor = '#f5f5f5'

let pageTheme
if ($('[data-page-theme]').data()) {
  pageTheme = $('[data-page-theme]').data()
} else {
  pageTheme = {
    pageTheme: 'pink',
  }
}

const themeColor = mapIconColors[pageTheme.pageTheme] ? mapIconColors[pageTheme.pageTheme].color : undefined

// Base64 encoded svgs, anchor point is bottom middle by default
const iconsBase64 = {
  default:
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDE0IDIxIj4KICAgIDxwYXRoIGQ9Ik0xMC41IDdjMC0xLS4zLTEuOC0xLTIuNVM4IDMuNSA3IDMuNXMtMS44LjMtMi41IDEtMSAxLjUtMSAyLjUuMyAxLjggMSAyLjUgMS41IDEgMi41IDEgMS44LS4zIDIuNS0xIDEtMS41IDEtMi41ek0xNCA3YzAgMS0uMiAxLjgtLjUgMi40TDguNiAyMGMtLjEuMy0uNC41LS42LjctLjQuMi0uNy4zLTEgLjMtLjMgMC0uNi0uMS0uOS0uMy0uMy0uMi0uNS0uNC0uNi0uN0wuNSA5LjRDLjIgOC44IDAgOCAwIDdjMC0xLjkuNy0zLjYgMi4xLTQuOVM1LjEgMCA3IDBzMy42LjcgNC45IDIuMVMxNCA1LjEgMTQgN3oiLz4KPC9zdmc+',
  dot:
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNyIgY3k9IjcuMzEyNSIgcj0iNyIgZmlsbD0iIzE5MTQxNCIvPgo8L3N2Zz4K',
  cluster:
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTMiIGZpbGw9IiMxOTE0MTQiLz4KPC9zdmc+',
  largeMarker:
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjciIHZpZXdCb3g9IjAgMCA2MCA2NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41IiBmaWx0ZXI9InVybCgjZmlsdGVyMF9mKSI+CjxwYXRoIGQ9Ik0xMCAyOS40OTIzQzEwIDE4LjczNTUgMTguOTU3NyAxMCAzMC4wMTE5IDEwQzQxLjA2NjEgMTAgNTAgMTguNzM1NSA1MCAyOS40OTIzQzUwIDM1LjMyMzggNDcuMzU1NiA0MC41NTEyIDQzLjIxMDIgNDQuMTI5TDMwLjAxMTkgNTdMMTYuODEzNiA0NC4xMjlDMTIuNjQ0NCA0MC41NzQ0IDEwIDM1LjMyMzggMTAgMjkuNDkyM1oiIGZpbGw9IiNFQzAwOEMiLz4KPC9nPgo8cGF0aCBkPSJNNDUgMjkuOTMwM0M0NSAyMS42OTExIDM4LjI4MTcgMTUgMjkuOTkxMSAxNUMyMS43MDA0IDE1IDE1IDIxLjY5MTEgMTUgMjkuOTMwM0MxNSAzNC4zOTY5IDE2Ljk4MzMgMzguNDAwOSAyMC4wOTIzIDQxLjE0MTRMMjkuOTkxMSA1MUwzOS44ODk4IDQxLjE0MTRDNDMuMDE2NyAzOC40MTg3IDQ1IDM0LjM5NjkgNDUgMjkuOTMwM1oiIGZpbGw9IiMxOTE0MTQiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMyIgZmlsbD0iI0Y4MDA5MyIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjAiIGhlaWdodD0iNjciIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNSIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=',
}

const svgMarker = {
  path:
    'M45.9 14.2C44.6 11.2 42.7 8.5 40.3 6.3C37.9 4.1 35.1 2.4 32 1.3C28.9 0.199999 25.7 -0.200001 22.4 0.0999991C16.5 0.699999 11 3.6 6.99999 8.1C2.99999 12.6 0.899995 18.5 0.999995 24.5C0.999995 30.8 3.09999 36.9 6.89999 41.9L24.5 65L41.7 42.5C45.8 37.1 48 30.5 48 23.7C47.9 20.4 47.2 17.2 45.9 14.2ZM29 27.5C28.4 28.4 27.5 29.1 26.5 29.5C25.5 29.9 24.4 30 23.3 29.8C22.2 29.6 21.3 29.1 20.5 28.3C19.7 27.5 19.2 26.5 19 25.5C18.8 24.4 18.9 23.3 19.3 22.3C19.7 21.3 20.4 20.4 21.3 19.8C22.2 19.2 23.3 18.9 24.4 18.9C25.1 18.9 25.8 19 26.5 19.3C27.2 19.6 27.8 20 28.3 20.5C28.8 21 29.2 21.6 29.5 22.3C29.8 23 29.9 23.7 29.9 24.4C30 25.5 29.7 26.6 29 27.5Z',
  fillColor: themeColor ?? '#FF32AA',
  fillOpacity: 1,
  strokeWeight: 0,
  rotation: 0,
  scale: 0.85,
  anchor: { x: 20, y: 30 },
}

export function initialize() {
  $('[data-map-canvas]').each((i, el) => {
    initMap(el)
  })

  window.addEventListener('updateMapData', event => {
    $('[data-map-canvas]').each((i, el) => {
      initMap(el, transformEventResultsToConfig(event.detail))
    })
  })
}

function transformEventResultsToConfig(eventResults) {
  return {
    childEventGroups: eventResults.events,
    visible: eventResults.view === 'map',
    searchLocation: eventResults.searchLocation,
  }
}

function initMap(mapDiv, extraOptions = {}) {
  const config = { ...$(mapDiv).data('map-canvas'), ...extraOptions }

  if (config.visible === false) {
    hideSection(mapDiv)
  } else {
    showSection(mapDiv)
  }

  const loader = new Loader({
    apiKey: config.apiKey,
    libraries: ['places'],
  })

  loader.load().then(google => {
    if (config.visible !== false) {
      let map = $(mapDiv).data('map')

      if (!map) {
        const mapOptions = createMapOptions(config)
        map = new google.maps.Map(mapDiv, mapOptions)
        $(mapDiv).data('map', map)
      }

      updateMarkers(map, config)
    }
  })
}

function showSection(canvas) {
  $(canvas)
    .parents('section[hidden]')
    .removeAttr('hidden')
}

function hideSection(canvas) {
  $(canvas)
    .parents('section')
    .attr('hidden', true)
}

function createMapOptions(config) {
  return {
    styles: mapStyles,
    zoom: 13,
    maxZoom: 21,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP,
    },
    draggable: !('ontouchend' in document && $(window).width <= 1024),
    backgroundColor: backgroundColor,
    panControl: true,
    zoomControl: true,
    scaleControl: true,
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },
    disableDoubleClickZoom: true,
    clickableIcons: false,
    scrollwheel: false,
    mapTypeControl: false,
    streetViewControl: false,
    overviewMapControl: false,
  }
}

/**
 * @param {google.maps.Map} map
 * @param {*} config
 */
function updateMarkers(map, config) {
  const { venues = [], locations = [], childEventGroups = [], searchLocation } = config
  clearMap(map)

  let allMarkers = []
  let searchLocationArea = null

  const venueMarkers = venues.map(venue => {
    return new google.maps.Marker({
      map,
      position: new google.maps.LatLng(venue.lat, venue.lng),
      icon: svgMarker,
    })
  })

  allMarkers = allMarkers.concat(venueMarkers)

  // const locationMarkers = locations.map(location => {
  //   return new google.maps.Marker({
  //     map,
  //     position: new google.maps.LatLng(location.lat, location.lng),
  //     icon: iconsBase64.dot,
  //   })
  // })

  // allMarkers = allMarkers.concat(locationMarkers)

  let childEventMarkers = []
  // childEventGroups.forEach(function(eventGroup) {
  //   // only include events with locations to prevent errors
  //   if (!eventGroup[0].locations.length) return null
  //   let marker
  //   for (let i = 0; i < eventGroup.length; i++) {
  //     let address = eventGroup[i].locations[0].address
  //     const radian = 2 * Math.PI * (i / eventGroup.length)

  //     marker = new google.maps.Marker({
  //       position: new google.maps.LatLng(
  //         address.lat + 360 * Math.cos(radian) * 0.00000065,
  //         address.lng + 360 * Math.sin(radian) * 0.00000065
  //       ),
  //       icon: iconsBase64.dot,
  //     })
  //     if (eventGroup.length > 14) {
  //     }
  //     const artistContent = [eventGroup[i]]
  //     marker.addListener('click', () => updateArtistContent(artistContent))
  //     childEventMarkers.push(marker)
  //   }
  // })

  const clusterer = new MarkerClusterer(map, childEventMarkers, {
    minimumClusterSize: 3,
    styles: [
      {
        textColor: 'white',
        url: iconsBase64.cluster,
        height: 26,
        width: 26,
      },
    ],
  })

  // if (searchLocation) {
  //   searchLocationArea = createSearchLocationArea(map, searchLocation)
  //   const searchLocationMarker = createSearchLocationMarker(map, searchLocation)

  //   searchLocationMarker.addListener('drag', () => searchLocationArea.setCenter(searchLocationMarker.getPosition()))
  //   searchLocationMarker.addListener('dragend', () => {
  //     const latLng = searchLocationMarker.getPosition().toJSON()
  //     map.getDiv().dispatchEvent(new CustomEvent('updateSearchLocation', { detail: latLng, bubbles: true }))
  //   })

  //   allMarkers.push(searchLocationArea)
  //   allMarkers.push(searchLocationMarker)
  // }

  let bounds = new google.maps.LatLngBounds()

  if (searchLocationArea) {
    bounds = searchLocationArea.getBounds()
  } else if (clusterer.getTotalMarkers() > 0) {
    clusterer.getMarkers().forEach(marker => {
      bounds.extend(marker.getPosition())
    })
  } else {
    allMarkers.forEach(marker => {
      bounds.extend(marker.getPosition())
    })
  }

  if (!bounds.isEmpty()) {
    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()
    const padding = 0.005
    bounds.extend(new google.maps.LatLng(ne.lat() - padding, ne.lng() - padding))
    bounds.extend(new google.maps.LatLng(sw.lat() + padding, sw.lng() + padding))
    map.fitBounds(bounds, 50)
    map.setCenter(bounds.getCenter())
  }

  $(map.getDiv()).data('clusterer', clusterer)
  $(map.getDiv()).data('allMarkers', allMarkers)
}

function clearMap(map) {
  const { clusterer, allMarkers } = $(map.getDiv()).data()
  if (clusterer) {
    clusterer.clearMarkers()
  }
  if (allMarkers) {
    allMarkers.forEach(marker => {
      marker.setMap(null)
    })
  }
}

/**
 * @param {google.maps.Map} map
 * @param {{ lat: number, lng: number, radius: number }} searchLocation
 * @returns {google.maps.Marker}
 */
function createSearchLocationMarker(map, searchLocation) {
  return new google.maps.Marker({
    map,
    position: new google.maps.LatLng(searchLocation.lat, searchLocation.lng),
    icon: iconsBase64.largeMarker,
    zIndex: -100,
    draggable: true,
  })
}

/**
 * @param {google.maps.Map} map
 * @param {{ lat: number, lng: number, radius: number }} searchLocation
 * @returns {google.maps.Circle}
 */
function createSearchLocationArea(map, searchLocation) {
  return new google.maps.Circle({
    strokeColor: '#ffffff',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#ffffff',
    fillOpacity: 0.25,
    map,
    clickable: false,
    center: new google.maps.LatLng(searchLocation.lat, searchLocation.lng),
    radius: searchLocation.radius * 1000,
  })
}

function updateArtistContent(eventGroup) {
  $('[data-artist-map-container]').html('')

  for (let i = 0; i < eventGroup.length; i++) {
    const html = createEventHtml(eventGroup[i])
    $('[data-artist-map-container]')
      .append(html)
      .trigger('ajax.replace')
  }
  // const html = eventGroup.map(createEventHtml).join('')
  // $('[data-artist-map-container]')
  // .html(html)
  // .trigger('ajax.replace')
}

function createEventHtml(event) {
  const location = event.locations[0]
  const session = event.sessions[0]
  const artist = event.artists[0]
  const content = `
  <div class="artist-content-inner flex flex-row">
      <div class="artist-image-container">
          <div class="artist-image media">
              <img src="/generated/480w-3-2/${artist.image.slug}.jpg" alt="${artist.title}" />
          </div>
      </div>
      <div class="artist-details padding-s align-self-center">
          <h3 class="line-height-xxs">${artist.title}</h3>
          <div class="flex flex-row no-margin justify-content-space-between">
          <p class="date small-caps small-caps-s no-margin">${getDate(session.datetime)}</p>
          <div class="event-favourite event-favourite-xs no-margin" style="float:right"
              data-event-favourite="${event.id}"
              data-event-title="${event.title}">
              <svg width="24" height="24"><use xlink:href="/assets/glyphs/glyphs.svg?cachebust=2024#heart-outline"></use></svg>
          </div>
      </div>
      <p class="location no-margin font-size-s color-black">${location.title}</p>
      <p class="location no-margin font-size-s color-black">${removeTags(location.text_address)}</p>
      <p class="no-margin font-size-s color-grey">${getTime(session.datetime) +
        (session.endtime ? ' - ' + getTime(session.endtime) : '')}*</p>
  </div>
`
  return content
}

// Convert artist event date
function getDate(date) {
  var readable_date = new Date(date)
  const day = readable_date.getDate()
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(readable_date)
  return day + ' ' + month
}

// Convert artist event time
function getTime(time) {
  if (time.length > 0) {
    var readable_date = new Date(time)
    let zone
    let hour = readable_date.getHours()
    let minutes = readable_date.getMinutes()
    hour < 13 ? (zone = 'am') : (zone = 'pm')
    hour < 13 ? null : (hour = hour - 12)
    minutes < 10 ? (minutes = '0' + minutes) : null
    return hour + ':' + minutes + zone
  } else {
    return ''
  }
}

function removeTags(str) {
  if (str === null || str === '') return false
  else str = str.toString()
  return str.replace(/(<([^>]+)>)/gi, '')
}
